/* コレクションの「もっと見る」（2026-08-04 追加）
 *
 * 次ページを取得して #facets-results に継ぎ足す。
 *
 * 方針:
 * - 素の JS で書く。テーマは Alpine v2 を使っているが、リスナー登録順の
 *   競合を過去に踏んでいるため（LESSONS: サイン会フォームの submit 横取り）、
 *   Alpine のライフサイクルには乗せない
 * - ボタンは Liquid 側で hidden。ここで外す＝JS が動く環境だけに出す。
 *   動かなければページ番号つきのページ送りがそのまま残る
 * - 参照する要素はすべて null ガードする（theme.liquid の pausedUI で
 *   全ページに TypeError を撒いた事故があるため）
 */
(function () {
  'use strict';

  var GRID_SELECTOR = '#facets-results';

  function init() {
    var wrap = document.querySelector('[data-cupick-load-more]');
    var grid = document.querySelector(GRID_SELECTOR);
    if (!wrap || !grid) return;

    var btn = wrap.querySelector('[data-load-more-btn]');
    if (!btn) return;

    var spinner = wrap.querySelector('[data-load-more-spinner]');
    var status = wrap.querySelector('[data-load-more-status]');
    var countEl = document.querySelector('.cupick-pagination__count');
    var totalItems = parseInt(btn.getAttribute('data-total-items'), 10) || 0;
    var loading = false;

    wrap.removeAttribute('hidden');

    // JS が動く環境では導線を「もっと見る」に一本化する。
    // ページ番号リストは DOM に残したまま視覚的に隠すだけ＝
    // クローラーと JS 無効環境には従来どおり見える（商品は sitemap にも
    // 453件載っているが、コレクションの構造とリンク評価は保っておく）。
    // 件数表示（1–48 / 305）は「まだある」と伝える情報なので残す。
    var pageList = document.querySelector('.cupick-pagination__list');
    if (pageList) pageList.setAttribute('data-js-hidden', '');

    btn.addEventListener('click', function () {
      if (loading) return;
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      loading = true;
      btn.disabled = true;
      if (spinner) spinner.removeAttribute('hidden');

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector(GRID_SELECTOR);
          if (!nextGrid) throw new Error('grid not found in response');

          var items = nextGrid.children;
          var added = items.length;
          // children は live collection なので後ろから移す
          var frag = document.createDocumentFragment();
          while (items.length) frag.appendChild(items[0]);
          grid.appendChild(frag);

          // 次の「次ページ」を引き継ぐ。無ければボタンごと消す
          var nextBtn = doc.querySelector('[data-load-more-btn]');
          var newNext = nextBtn ? nextBtn.getAttribute('data-next-url') : null;
          if (newNext) {
            btn.setAttribute('data-next-url', newNext);
          } else {
            wrap.setAttribute('hidden', '');
          }

          var shown = grid.children.length;
          if (countEl && totalItems) {
            countEl.textContent = countEl.textContent.replace(
              /\d+\s*[–-]\s*\d+/,
              '1–' + shown
            );
          }
          if (status) {
            status.textContent = added + ' / ' + shown + ' / ' + totalItems;
          }

          // 遅延読み込みのライブラリに追加分を拾わせる
          if (window.lazySizes && typeof window.lazySizes.autoSizer === 'object') {
            window.lazySizes.autoSizer.checkElems();
          }
          document.dispatchEvent(
            new CustomEvent('cupick:products-appended', { detail: { added: added, shown: shown } })
          );
        })
        .catch(function (err) {
          // 失敗してもページ番号のリンクは生きているので、ボタンを戻すだけ
          if (window.console && console.warn) console.warn('[load-more]', err);
        })
        .then(function () {
          loading = false;
          btn.disabled = false;
          if (spinner) spinner.setAttribute('hidden', '');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
